<template>
  <div class="medialist-classic">
    <div v-if="value.length">
      <ul class="view-table-list">
        <li v-for="(item, index) in value" :key="item.id">
          <v-row no-gutters>
            <v-icon small v-if="item.type && item.type.includes('spreadsheet')" class="mr-1" color="green">mdi-file-excel</v-icon>
            <v-icon small v-else-if="item.type && item.type.includes('word')" class="mr-1" color="blue">mdi-file-word</v-icon>
            <v-icon small v-else-if="item.type && item.type.includes('pdf')" class="mr-1" color="red">mdi-file-pdf</v-icon>
            <v-icon small v-else-if="item.type && item.type.includes('application/zip')" class="mr-1" color="orange darken-3">mdi-archive</v-icon>
            <v-icon small v-else class="mr-1" color="cyan lighten-2">mdi-file-image</v-icon>

            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="medialist-item"><a target="_blank" :href="item.url">{{ item.name| truncate_middle(14, '...') }}</a><span class="grey--text"> {{ item.size|prettyBytes }}</span></span>
              </template>
              <span>{{ item.name }} - {{ item.created_by.name }} - {{ item.date_created }}</span>
            </v-tooltip>

            <v-spacer></v-spacer>
            <span v-if="(view === 'edit' || view === 'create') && !disabled">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <span v-on="on"><v-icon small class="pointer" color="#D50000" @click="openConfirmation(item, index)">mdi-cancel</v-icon></span>
                </template>
                <span>Удалить</span>
              </v-tooltip>
            </span>
          </v-row>
        </li>
      </ul>
    </div>
    <div v-if="value.length === 0 && view === 'view'" class="no-data-files">Нет данных</div>

    <div v-if="!only_one || (only_one && value.length === 0)">
      <div v-if="view === 'edit' || view === 'create'">
        <v-file-input
          v-model="files"
          @change="uploadFiles"
          multiple
          :capture="capture"
          :accept="accept"
          :key="uploadComponentKey"
          :clearable="false"
          :disabled="uploadPending || disabled"
        >
        <template v-slot:label>
          <span class="grey--text">{{ label }}</span>
        </template>
        </v-file-input>
      <v-progress-linear
        v-if="uploadPercentage > 0 && uploadPercentage < 100"
        color="lime"
        height="20"
        :value="uploadPercentage"
        striped
      >
      <template>
        <span>{{ uploadPercentage }}%</span>
      </template>
      </v-progress-linear>
    </div>
  </div>

  <Confirmation
    :opened="confirmation.opened"
    :title="confirmation.title"
    :text="confirmation.text"
    :pendingSave="confirmation.pendingSave"
    @confirm="confirmConfirmationAction"
    @cancel="cancelConfirmationAction"
  />
  </div>
</template>

<script>
import { upload, remove } from '@/api'
import Confirmation from '@/components/Confirmation'

export default {
  components: {
    Confirmation
  },
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    id: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: 'Прикрепите ваши документы'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ''
    },
    capture: {
      type: [Boolean, String],
      default: false
    },
    accept: {
      type: [Boolean, String],
      default: false
    },
    view: {
      type: String,
      default: 'view'
    },
    params: {
      type: Object,
      default: function () {
        return {}
      },
    },
    only_one: {
      type: Boolean,
      default: false
    },
    acl: {
      type: Object,
      default: function () {
        return {
          add: null,
          change: null,
          view: null,
          delete: null
        }
      },
    },
  },
  data () {
    return {
      files: [],
      uploadComponentKey: 0,
      uploadPercentage: 0,
      uploadPending: false,
      removePending: false,

      // confirm
      confirmation: {
        opened: false,
        text: '',
        title: '',
        id: null,
        index: null,
        pendingSave: null
      },
    }
  },
  methods: {
    uploadFiles () {
      if (!this.files) { return }

      const formData = new FormData()
      for (const file of this.files) {
        formData.append('file[]', file, file.name)
      }
      formData.append('id', this.id)

      this.uploadPending = true
      const onUploadProgress = function (progressEvent) {
        this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
      }.bind(this)

      upload(this.url, this.id, formData, onUploadProgress, this.params)
        .then((response) => {
          this.uploadPending = false
          for (const [key, value] of Object.entries(response.data)) {
            this.value.push(value)
          }
          this.files = []
        }).catch((err) => {
          this.uploadPending = false
          this.files = []
          this.$notify({ group: 'main', title: 'Загрузка', text: 'Ошибка! ' + err.response.status + ' ' + err.response.statusText, type: 'error' })
        })
      // need for rerender component (chrome issue with same name files upload)
      this.uploadComponentKey += 1
    },
    // delete
    openConfirmation (item, index) {
      this.confirmation.opened = true
      this.confirmation.text = `Уверены, что хотите удалить объект ${item.name}?`
      this.confirmation.title = 'Удаление'
      this.confirmation.id = item.id
      this.confirmation.index = index
    },
    cancelConfirmationAction () {
      this.confirmation.opened = false
    },
    confirmConfirmationAction (id) {
      this.confirmation.pendingSave = true
      remove(this.url, this.id, `remove/${this.confirmation.id}/`).then(() => {
        this.confirmation.pendingSave = false
        this.confirmation.confirm = false
        this.confirmation.opened = false
        this.value.splice(this.confirmation.index, 1)
      }).catch((err) => {
        this.confirmation.confirm = false
        this.confirmation.pendingSave = false
        this.$notify({ group: 'main', title: 'Загрузка', text: 'Ошибка! ' + err.response.status + ' ' + err.response.statusText, type: 'error' })
      })
    }
  }
}
</script>
<style scoped>
.medialist-item {
  font-size: 14px !important;
  margin: auto;
}
</style>
